import {Component, EventEmitter, HostListener, OnDestroy, OnInit, Output, ViewChild,} from '@angular/core';
import {FormBuilder, FormControl, FormGroup} from '@angular/forms';
import {select, Store} from '@ngrx/store';
import {combineLatest, debounceTime, distinctUntilChanged, filter, Subscription, take,} from 'rxjs';
import {selectCaseInformations} from '../../../../store/selectors/case-informations.selector';
import {selectBlackList, selectCaseApproved, selectIsExcelData, selectReadonly,} from '../../../../store/selectors/common-case.selector';
import {Option} from '../../../../../../ui-components/core-dropdown/core-dropdown.component';
import {selectDropdownLoaded, selectDropdownOptions,} from '../../../../store/selectors/dropdowns.selector';
import {ICaseInformations} from '../../../../interfaces/interfaces';
import {MemberInputComponent} from './components/member-input/member-input.component';
import {DiagnosesSavedType} from '../../../../../../shared/components/medical-records/medical-records.component';
import {ParameterService} from '../../../../../../shared/services/parameter/parameter.service';
import {StaffService} from '../../../../../definition/staff/services/staff.service';
import {AppAlertService} from '../../../../../../shared/services/app-alert/app-alert.service';
import {selectServiceInformations} from '../../../../store/selectors/service-informations.selector';

@Component({
  selector: 'app-case-informations',
  templateUrl: './case-informations.component.html',
  styleUrl: './case-informations.component.scss',
})
export class CaseInformationsComponent implements OnInit, OnDestroy {
  @ViewChild('memberInput') memberInput: MemberInputComponent;
  subscriptions = new Subscription();
  form: FormGroup;
  blackList: string[] = [];
  hiddenFields: { [key: string]: boolean } = {};
  assuranceTypes: Option[];
  freeTypes: Option[];
  assuranceFreeType: number | null;
  assuranceCorporateType: number | null;
  assuranceIndividualType: number | null;
  causeReasons: Option[];
  serviceReasons: Option[];
  serviceReasonsParameters: any[];
  triages: Option[];
  staffList: Option[]; //Vaka Bilgileri - Sorumlu Personel Seçimi
  priceTypes: Option[];
  icdCodeList: any[];
  @Output() formChanged = new EventEmitter();
  isReadOnly: boolean = false;
  readonlyInformations: ICaseInformations | null;
  institutions: Option[] = [];
  showMemberDialog: boolean = false;
  private formSubscriptions = new Subscription();
  isCaseApproved: boolean | null;
  serviceInformations: any[] = []

  isExcelData: boolean = false;
  constructor(
    private readonly store: Store,
    private readonly fb: FormBuilder,
    private readonly parameterService: ParameterService,
    private readonly staffService: StaffService,
    private readonly alertService: AppAlertService
  ) {
  }

  ngOnInit(): void {
    this.parameterService
      .getParameterValues('case-parameters', 'case-service-reason')
      .subscribe((response) => {
        this.serviceReasonsParameters = response.datas.values.map((data: any) => {
          return {
            label: data?.valueObject?.name?.value,
            value: data?.valueObject?.id?.value,
            triage: data?.valueObject['case-triages']?.value,
          };
        });
      });

    this.staffService.getStaffSelectInCase().subscribe({
      next: (response) => {
        this.staffList = response.map(staff => ({
          label: `${staff.firstName} ${staff.lastName}`,
          value: Number(staff.id),
        }));
      },
      error: (err) => {
      },
    });

    this.form = this.fb.group({
      assuranceType: new FormControl(null),
      freeType: new FormControl(null),
      priceType: new FormControl(null),
      institution: new FormControl(null),
      memberFullname: new FormControl(null),
      memberContractNo: new FormControl(null),
      memberNo: new FormControl(null),
      causeReason: new FormControl(null),
      serviceReason: new FormControl(null),
      protocolNo: new FormControl(null),
      labmedNo: new FormControl(null),
      triage: new FormControl(null),
      userNote: new FormControl(null),
      complaint: new FormControl(null),
      diagnoses: new FormControl([]),
      staff: new FormControl(null),
      supportStaff: new FormControl(null),
      time: new FormControl(null),
      department: new FormControl(null),
      supplier: new FormControl(null),

    });

    this.listenForm();

    combineLatest([
      this.store.pipe(select(selectDropdownOptions('assuranceTypes'))),
      this.store.pipe(select(selectDropdownOptions('freeTypes'))),
      this.store.pipe(select(selectDropdownOptions('assuranceFreeType'))),
      this.store.pipe(select(selectDropdownOptions('assuranceCorporateType'))),
      this.store.pipe(select(selectDropdownOptions('assuranceIndividualType'))),
      this.store.pipe(select(selectDropdownOptions('causeReasons'))),
      this.store.pipe(select(selectDropdownOptions('serviceReasons'))),
      // this.store.pipe(select(selectDropdownOptions('icdCodeList'))),
      this.store.pipe(select(selectDropdownOptions('triages'))),
      this.store.pipe(select(selectDropdownOptions('priceTypes'))),
      this.store.pipe(select(selectDropdownOptions('institutions'))),
      this.store.pipe(select(selectDropdownLoaded)),
    ])
      .pipe(
        // loaded flag'ı true olduğunda (yani veriler yüklendiğinde) veri akışı devam eder
        filter(
          ([
             assuranceTypes,
             freeTypes,
             assuranceFreeType,
             assuranceCorporateType,
             assuranceIndividualType,
             causeReasons,
             serviceReasons,
            //  icdCodeList,
             triages,
             priceTypes,
             institutions,
             loaded,
           ]) => loaded
        ),
        take(1)
      )
      .subscribe(
        ([
           assuranceTypes,
           freeTypes,
           assuranceFreeType,
           assuranceCorporateType,
           assuranceIndividualType,
           causeReasons,
           serviceReasons,
          //  icdCodeList,
           triages,
           priceTypes,
           institutions,
           loaded,
         ]) => {
          this.assuranceTypes = assuranceTypes;
          this.assuranceFreeType = assuranceFreeType;
          this.assuranceCorporateType = assuranceCorporateType;
          this.assuranceIndividualType = assuranceIndividualType;
          this.freeTypes = freeTypes;
          this.causeReasons = causeReasons;
          this.serviceReasons = serviceReasons;
          // this.icdCodeList = icdCodeList;
          this.triages = triages;
          this.priceTypes = priceTypes;
          this.institutions = institutions;

        }
      );

    this.subscriptions.add(
      this.store
        .select(selectCaseInformations)
        .pipe(distinctUntilChanged())
        .subscribe((caseInformations) => {
          this.readonlyInformations = caseInformations
            ? {...caseInformations}
            : null;

          this.form.patchValue({
            assuranceType: caseInformations?.assuranceType?.value,
            freeType: caseInformations?.freeType?.value,
            priceType: caseInformations?.priceType?.value,
            causeReason: caseInformations?.causeReason?.value,
            institution: caseInformations?.institution?.value,
            memberFullname: caseInformations?.memberFullname,
            memberContractNo: caseInformations?.memberContractNo,
            memberNo: caseInformations?.memberNo,
            serviceReason: caseInformations?.serviceReason?.value,
            protocolNo: caseInformations?.protocolNo,
            labmedNo: caseInformations?.labmedNo,
            triage: caseInformations?.triage?.value,
            userNote: caseInformations?.userNote,
            complaint: caseInformations?.complaint,
            diagnoses: caseInformations?.diagnoses,
            staff: caseInformations?.staff,
            supportStaff: caseInformations?.supportStaff,
            time: caseInformations?.time,
            department: caseInformations?.department,
            supplier: caseInformations?.supplier,
          });
          setTimeout(() => {
            if (this.memberInput) {
              this.memberInput.setMemberValue({
                memberFullname: caseInformations?.memberFullname ?? null,
                memberContractNo: caseInformations?.memberContractNo ?? null,
                memberNo: caseInformations?.memberNo ?? null,
              });
            }
          }, 150);

          const triageControl = this.form.get('triage');
          const serviceReasonValue = this.form.get('serviceReason')?.value;

          if (serviceReasonValue) {
            triageControl?.disable({emitEvent: false});
          } else {
            triageControl?.enable({emitEvent: false});
          }

          this.form.markAsPristine();
        })
    );

    const formPriceType = this.form.get('priceType')?.value;

    if (!formPriceType && this.priceTypes?.length) {
      const cariFiyatItem = this.priceTypes.find(
        (item: any) =>
          item.label?.toLowerCase()?.includes('cari fiyat')
      );

      if (cariFiyatItem) {
        this.form.get('priceType')?.setValue(cariFiyatItem.value, {
          emitEvent: false,
        });
      }
    }

    // Blacklist
    this.subscriptions.add(
      this.store
        .select(selectBlackList)
        .pipe(distinctUntilChanged())
        .subscribe((blackList) => {
          this.blackList = blackList;
          this.updateHiddenFields();
        })
    );

    // Readonly flag
    this.subscriptions.add(
      this.store
        .select(selectReadonly)
        .pipe(distinctUntilChanged())
        .subscribe((isReadOnly) => {
          this.isReadOnly = isReadOnly;
          const triageControl = this.form.get('triage');
          if (triageControl && (isReadOnly || !this.form.get('serviceReason')?.value)) {
            triageControl.disable({emitEvent: false});
          }
        })
    );

    // Onaylı mı
    this.subscriptions.add(
      this.store
        .select(selectCaseApproved)
        .pipe(distinctUntilChanged())
        .subscribe((isApproved) => {
          this.isCaseApproved = isApproved;
        })
    );

      this.subscriptions.add(
      this.store
        .select(selectIsExcelData)
        .pipe(distinctUntilChanged())
        .subscribe((isExcelData) => {
          this.isExcelData = isExcelData;
        })
    );
    this.subscriptions.add(
      this.store.select(selectServiceInformations)
        .pipe(distinctUntilChanged())
        .subscribe((serviceInformations) => {
          this.serviceInformations = serviceInformations?.services ?? [];
        })
    );
    this.form.get('serviceReason')?.valueChanges.subscribe(value => {
      const triageControl = this.form.get('triage');

      if (value) {
        const defaultTriage = this.getTriageForServiceReason(value);
        triageControl?.setValue(defaultTriage, {emitEvent: false});

        triageControl?.disable({emitEvent: false});
      } else {
        triageControl?.enable({emitEvent: false});
        triageControl?.setValue(null, {emitEvent: false});
      }
    });


  }

  getTriageForServiceReason(serviceReason: any) {
    if (!serviceReason || !this.serviceReasonsParameters?.length) {
      return null;
    }
    const matched: any = this.serviceReasonsParameters.find(
      param => param.value === serviceReason
    );

    return matched?.triage ?? null;

  }

  async getFormValues(): Promise<any> {
    const values = this.form.getRawValue();
    const savedPriceType = this.readonlyInformations?.priceType?.value;

    // Koşul sağlanıyorsa onay iste
    if (this.serviceInformations.length > 0 && savedPriceType !== values?.priceType) {
      const confirmed = await new Promise<boolean>((resolve) => {
        this.alertService.sweetConfirm({
          header: 'Kayıtlı Hizmetler Silinecek',
          message: 'Fiyat Tipi Değiştiği için hizmetler silinecek. Devam etmek istediğinize emin misiniz?',
          showCloseButton: true, 
          accept: () => resolve(true),
          reject: () => resolve(false),
        });
      });

      if (!confirmed) return false;
    }

    return values;
  }

  get diagnoses(): any[] {
    return this.form?.get('diagnoses')?.value || [];
  }

  updateMedicalRecords(updatedMedicalRecords: any[]) {
    this.form.patchValue({
      diagnoses: updatedMedicalRecords.map((e) => ({
        ...e,
        savedType: e?.savedType ?? DiagnosesSavedType.user,
      })),
    });
    this.form.markAsDirty();
  }

  listenForm() {
    if (this.formSubscriptions) {
      this.formSubscriptions.unsubscribe();
    }
    this.formSubscriptions = new Subscription(); // yeni bir set başlat

    this.formSubscriptions.add(
      this.form
        .get('assuranceType')
        ?.valueChanges.subscribe((assuranceType) => {
        if (assuranceType !== this.assuranceFreeType) {
          this.form.get('freeType')?.setValue(null);
        }
        if (assuranceType !== this.assuranceCorporateType) {
          this.form.get('institution')?.setValue(null);
        }
        if (assuranceType !== this.assuranceIndividualType) {
          this.form.patchValue({
            memberNo: null,
            memberFullname: null,
            memberContractNo: null,
          });
        }
      })
    );

    this.formSubscriptions.add(
      this.form.valueChanges.pipe(debounceTime(300)).subscribe(() => {
        if (this.form.dirty) {
          this.formChanged.emit();
        }
      })
    );
  }

  updateHiddenFields(): void {
    for (const key of Object.keys(this.form.controls)) {
      this.hiddenFields[key] = this.blackList.includes(key);
    }
  }

  onMemberSelect(
    selected: { selectedMember: any; selectedMemberDetail: any } | null
  ) {
    this.form.patchValue({
      memberNo: selected?.selectedMember
        ? selected?.selectedMember?.uyelik_id
        : null,
      memberContractNo: selected?.selectedMemberDetail
        ? selected?.selectedMemberDetail?.sozlesme_id
        : null,
      memberFullname: selected?.selectedMember
        ? selected.selectedMember?.fullname
        : null,
    });

    this.form.markAsDirty();
    this.form.updateValueAndValidity();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload(event: Event): void {
    this.unSub();
  }

  unSub() {
    if (this.formSubscriptions) {
      this.formSubscriptions.unsubscribe();
    }
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }

  ngOnDestroy(): void {
    this.unSub();
  }
}
